let ELAPSED_TIME = 0;

export const getElapsedTime = () => {
    return ELAPSED_TIME;
};

export const setElapsedTime = (elapsedTime) => {
    ELAPSED_TIME = elapsedTime;
};

export const getRemainingTime = () => {
    return MAX_INACTIVITY_TIME - ELAPSED_TIME;
};

let ELAPSED_CONFIG_TIME = 0;

export const getElapsedConfigTime = () => {
    return ELAPSED_CONFIG_TIME;
};

export const setElapsedConfigTime = (elapsedConfigTime) => {
    ELAPSED_CONFIG_TIME = elapsedConfigTime;
};

export const getRemainingConfigTime = () => {
    return CONFIG_PRESS_TIME - ELAPSED_CONFIG_TIME;
};

export const MAX_INACTIVITY_TIME = 300; // Seconds. Default: 300

export const INACTIVITY_MODAL_TIME = 240; // Seconds. Default: 240

export const EXTERNAL_CHECKOUT_IFRAME_MAX_TIME = 15 * 60; // 15 Minutes

export const LOG_INACTIVITY_TIME = false; // Default: false

export const CONFIG_PRESS_TIME = 5; // Seconds.

export const SHOW_APP_VERSION = true;

export const PLP_ITEMS_PER_PAGE = 100;

export const SCHEDULED_PLAYLIST_RATE = 1000 * 60 * 10; // 10 Minutes.

export const PRODUCT_BOX_3D_DEFAULT_CONFIG = {fov: 'auto', radius: '100%'};

export const PLP_3D_DEFAULT_CONFIG = {fov: 'auto', radius: '120%'};

export const PLP_3D_FULLSCREEN_CONFIG = {fov: 'auto', radius: '100%'};

export const GET_SERVER_TIMESTAMP_URL = 'https://getservertimestamp-x3herayjcq-uc.a.run.app';

export const CLIENT_CHECKOUT_URL = 'https://getcheckout-x3herayjcq-uc.a.run.app';

export const UPDATE_PRODUCT_URL = 'https://extractitemsbyskulist-x3herayjcq-uc.a.run.app';

export const GET_CLIENT_ENTITY_URL = 'https://getcliententity-x3herayjcq-uc.a.run.app';

export const GET_SII_ENTITY_URL = 'https://getsiientity-x3herayjcq-uc.a.run.app';

export const GET_STATES_URL = 'https://getstates-x3herayjcq-uc.a.run.app';

export const GET_DISTRICTS_URL = 'https://getdistricts-x3herayjcq-uc.a.run.app';

export const GET_CITIES_URL = 'https://getcities-x3herayjcq-uc.a.run.app';

export const GET_ACTIVITIES_URL = 'https://getactivities-x3herayjcq-uc.a.run.app';

export const GET_HQ_DATA_URL = 'https://gethqdata-x3herayjcq-uc.a.run.app';

export const GET_SEGMENTS_URL = 'https://getsegments-x3herayjcq-uc.a.run.app';

export const SAVE_CUSTOMER_URL = 'https://savecustomer-x3herayjcq-uc.a.run.app';

export const SAVE_ORDER_V2_URL = 'https://saveorderv2-x3herayjcq-uc.a.run.app';

export const GET_ORDER_SIGNING_KEY_URL = 'https://getordersigningkey-x3herayjcq-uc.a.run.app';

export const POS_POLL_URL = 'https://localhost:5001/poll';

export const POS_SALE_URL = 'https://localhost:5001/sale';

export const SENTRY_ERROR_TESTING_MODE = false;

export const ACTION_BAR_ITEMS = {
    'catalog': ['home', 'search', 'help', 'survey', 'cart'],
    'products-list': ['home', 'search', 'help', 'survey', 'cart', 'back'],
    'product': ['home', 'search', 'cart', 'help', 'survey', 'back']
};

export const PRICE_FILTER_STEP_THRESHOLD = 100000;

export const PRICE_FILTER_LOWER_STEP = 1000;

export const PRICE_FILTER_HIGER_STEP = 10000;

export const OTHER_FILTERS_IGNORED_KEYS = [
    'descripción', 'Descripción', 'descripcion', 'Descripcion',
    'modelo', 'Modelo',
    'marca', 'Marca',
    'dimensiones', 'Dimensiones',
    'precio', 'Precio',
    'precios', 'Precios',
    'alto', 'Alto',
    'ancho', 'Ancho',
    'largo', 'Largo',
    'profundidad', 'Profundidad'
];

export const SENTRY_ENABLED_ENVIRONMENTS = ['production', 'staging'];